import { ArrowBack, Close } from '@mui/icons-material';
import { IconButton, Stack, Typography } from '@mui/material';
import type React from 'react';
import type { ReactNode } from 'react';

type ModalV2HeaderProps = {
    onClose?: () => void;
    goBack?: () => void;
    children?: ReactNode;
};

const ModalV2Header: React.FC<ModalV2HeaderProps> = ({ onClose, goBack, children }) => {
    const hasButtons = Boolean(goBack || onClose);
    return (
        <Stack
            direction='row'
            alignItems='center'
            justifyContent='space-between'
            borderBottom={(t) => `1px solid ${t.palette.divider}`}
        >
            {hasButtons && (
                <IconButton
                    size={'large'}
                    onClick={goBack}
                    sx={{
                        visibility: goBack ? 'visible' : 'hidden',
                        m: 1,
                    }}
                >
                    <ArrowBack fontSize='large' />
                </IconButton>
            )}

            <Typography
                color='primary'
                variant='h6'
                p={{ xs: 1, sm: 2 }}
                sx={{
                    textAlign: 'center',
                }}
            >
                {children}
            </Typography>

            {hasButtons && (
                <IconButton size={'large'} onClick={onClose} sx={{ m: 1, visibility: onClose ? 'visible' : 'hidden' }}>
                    <Close fontSize='large' />
                </IconButton>
            )}
        </Stack>
    );
};

export default ModalV2Header;
